import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CidEnvService {

  environment = [
    {key: 'localhost',value: 97110105107},
    {key: 'dev.anikinitek.com',value: 97110105107},
    // {key: 'amsp.acpl.live',value: 9799112108},
    {key: 'amsp.rvrdigital.in',value: 114118114100},
    // {key: 'demo.assetto.biz',value: 80720251144},
    {key: 'demo1.assetto.biz',value: 1409202516},
    {key: "amsp.tiyatel.com", value: 202602131205}

  ];

  constructor() { }

  getCid(hostname:any):any {
    for(let i = 0; i < this.environment.length; i++) {
      if(this.environment[i].key == hostname){
        return Number(this.environment[i].value)
      }
    }
  }
}
